import { ErrorPanel } from "lib-core"
export { ErrorPanel }

export default ErrorPanel